module.exports = __webpack_public_path__ + "static/media/soma-mockup.252e2cd1.jpg";